import { apiCall, createQueryString } from "../imports"

const PREFIX = "shop/shippings"

export default {

    getShippings(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },

    createShippings(data) {
        return apiCall('post', `${PREFIX}`, data)
    },

    updateShippings(shippingID, data) {
        return apiCall('post', `${PREFIX}/${shippingID}/update`, data)
    },
    

    deleteShippings(shippingID) {
        return apiCall('delete', `${PREFIX}/${shippingID}`)
    },

    getShippingPrice(id){
        return apiCall('get', `${PREFIX}/shipping-prices/${id}`)

    },

    createShippingPrices(shippingID,data) {
        return apiCall('post', `${PREFIX}/${shippingID}/shipping-prices`, data)
    },

    updateShippingPrices(shippingID, shippingPriceID, data) {
        return apiCall('patch', `${PREFIX}/${shippingID}/shipping-prices/${shippingPriceID}`, data)
    },

    deleteShippingPrices(shippingID, shippingPriceID) {
        return apiCall('delete', `${PREFIX}/${shippingID}/shipping-prices/${shippingPriceID}`)
    }
}